"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateScreen = void 0;

var _validateProperty = require("ui-addon-upgrades/_core/common/data/upgradeData/validators/validateProperty");

var validateScreen = function validateScreen(screen) {
  var isValidScreen = typeof screen === 'string' && screen.length > 0;
  return (0, _validateProperty.validateProperty)(isValidScreen, "expected screen to be a non-empty string but got " + screen, 'screen');
};

exports.validateScreen = validateScreen;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/data/upgradeData/validators/validateScreen.js
// module id = 666
// module chunks = 5 6